<div class="network-summary-charts">

  <div id="routing-attempt-chart-container">
    <div class="chart-expand-compress-buttons">
      <button class="fa fa-expand" (click)="openRoutingAttemptsChartDialog()"></button>
    </div>
    <div class="chart-summary-container">
      <arm-highchart [options]="routingAttemptsChartOptions"></arm-highchart>
    </div>
  </div>

  <div id="unsuccessful-routes-chart-container">
    <div class="chart-expand-compress-buttons">
      <button class="fa fa-expand" (click)="openUnsuccessfulRoutesChartDialog()"></button>
    </div>
    <div class="chart-summary-container">
      <arm-highchart [options]="unsuccessfulRoutesChartOptions"></arm-highchart>
    </div>
  </div>

  <div id="calls-chart-container">
    <div class="chart-expand-compress-buttons">
      <button class="fa fa-expand" (click)="openCallsChartDialog()"></button>
    </div>
    <div class="chart-summary-container">
      <arm-highchart [options]="callsChartOptions"></arm-highchart>
    </div>
  </div>
</div>
